import React, { useState } from "react";
import languages from "../../../data/languages.json";
import { ProgressSectionProps } from "../types";
import LanguageDropdown from "./LanguageDropdown";

const ProgressSection: React.FC<ProgressSectionProps> = ({
  selectedLanguage,
  selectedLanguageCode,
  setSelectedLanguageCode,
  currentLevel,
  setCurrentLevel,
  getLevelDescription,
}) => {
  const [languageSearchTerm, setLanguageSearchTerm] = useState("");
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);

  return (
    <section aria-label="Practice setup" className="border-b border-white/10 pb-5">
      <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
        <div className="min-w-0 flex-1">
          <div className="mb-2 flex items-center justify-between gap-4">
            <label htmlFor="visual-practice-difficulty" className="text-sm font-medium text-white">
              Difficulty
            </label>
            <span className="text-sm tabular-nums text-white/55">
              Level {currentLevel} · {getLevelDescription(currentLevel)}
            </span>
          </div>
          <input
            id="visual-practice-difficulty"
            type="range"
            min="1"
            max="100"
            value={currentLevel}
            onChange={(event) => setCurrentLevel(Number.parseInt(event.target.value, 10))}
            className="visual-practice-slider h-11 w-full cursor-pointer appearance-none bg-transparent"
            aria-valuetext={`Level ${currentLevel}, ${getLevelDescription(currentLevel)}`}
          />
        </div>

        <LanguageDropdown
          selectedLanguage={selectedLanguage}
          selectedLanguageCode={selectedLanguageCode}
          setSelectedLanguageCode={setSelectedLanguageCode}
          languages={languages}
          isOpen={isLanguageDropdownOpen}
          setIsOpen={setIsLanguageDropdownOpen}
          languageSearchTerm={languageSearchTerm}
          setLanguageSearchTerm={setLanguageSearchTerm}
        />
      </div>

      <style jsx>{`
        .visual-practice-slider::-webkit-slider-runnable-track {
          height: 4px;
          border-radius: 999px;
          background: linear-gradient(
            to right,
            #fd954f 0%,
            #fd954f ${currentLevel}%,
            rgba(255, 255, 255, 0.14) ${currentLevel}%,
            rgba(255, 255, 255, 0.14) 100%
          );
        }

        .visual-practice-slider::-webkit-slider-thumb {
          width: 18px;
          height: 18px;
          margin-top: -7px;
          appearance: none;
          border: 2px solid #0f0f14;
          border-radius: 50%;
          background: #fd954f;
        }

        .visual-practice-slider::-moz-range-track {
          height: 4px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.14);
        }

        .visual-practice-slider::-moz-range-progress {
          height: 4px;
          border-radius: 999px;
          background: #fd954f;
        }

        .visual-practice-slider::-moz-range-thumb {
          width: 18px;
          height: 18px;
          border: 2px solid #0f0f14;
          border-radius: 50%;
          background: #fd954f;
        }
      `}</style>
    </section>
  );
};

export default ProgressSection;
